import { inView } from "global/inview.src";

(function ready(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
})(function() {

    inView({
        elems: document.querySelectorAll('.in-view'),
        onVisible: function(elem) {
            elem.classList.add('visible');
            elem.classList.add('animation-running');
        },
        tolerance: 0.25
    });

});
